// 数据字典
import { BaseModel } from '../BaseModel';
export  class DataElement extends BaseModel{    
    ElementCode:string= ""
    ElementName:string= ""
    SortNumber:string= "10"
    Remark: string=""
    DomainCode: string=""
    Status:number= 1
}